import { EnBubbleEvent } from "../enum/en-bubble-event.enum";

export interface IBubble {
    
    $event: any;
    bubbleEvent: EnBubbleEvent;
    params: any;
}
